export const ACTION_TYPES = {
  GET_CLAIMS_SUBSCRIPTION_BY_NUMBER: 'contract/GET_CLAIMS_SUBSCRIPTION_BY_NUMBER',
  GET_SUBSCRIPTION_BY_CLIENT: 'contract/GET_SUBSCRIPTION_BY_CLIENT',
  GET_SUBSCRIPTION_BY_NUMBER: 'contract/GET_SUBSCRIPTION_BY_NUMBER',
  UPDATE_INFO_CLIENT: 'contract/UPDATE_INFO_CLIENT',
  SET_PAGE: 'contract/SET_PAGE',
  GET_PRODUCT_OFFRE: 'contract/GET_PRODUCT_OFFRE',
  RESET_CONTRACT: 'contract/RESET_CONTRACT',
  GET_LIST_IMPYE_INFO: 'contract/GET_LIST_IMPYE_INFO',
  GET_CONTRACTUEL_DOCUMENTS: 'contract/GET_CONTRACTUEL_DOCUMENTS',
  RECOVER_ACTIVATE_SUBSCRIPTIONS: 'contract/RECOVER_ACTIVATE_SUBSCRIPTIONS',
  RESET_USER_INFO: 'contract/RESET_USER_INFO',
};
